import {
  ANONYMOUS_WISHLIST_ID_NAME,
  ANONYMOUS_WISHLIST_TOKEN_NAME,
} from "@/utils/const";
import { AUTH_COOKIE_NAME } from "@app/_auth/helpers";
import { WishlistItemWithTagsDto } from "@server/gql/graphql";
import { getCookie, setCookie } from "cookies-next";

export type Wishlist = {
  items: WishlistItemWithTagsDto[];
  total: number;
};

export function getWishlistCookies() {
  const token = getCookie(AUTH_COOKIE_NAME)?.toString();
  const wishlistId = parseInt(
    getCookie(ANONYMOUS_WISHLIST_ID_NAME)?.toString() ?? "",
    10,
  );
  const wishlistToken = getCookie(ANONYMOUS_WISHLIST_TOKEN_NAME)?.toString();
  return {
    token,
    wishlistId,
    wishlistToken,
  };
}

export function setWishlistCookies(id: number, token: string) {
  setCookie(ANONYMOUS_WISHLIST_ID_NAME, id.toString());
  setCookie(ANONYMOUS_WISHLIST_TOKEN_NAME, token);
}
